import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Typography, Button, CircularProgress } from "@material-ui/core";

import { useWalletConnect } from '../contexts/WalletConnect';
import { TezosToolkit } from "@taquito/taquito"
// import { TezBridgeSigner } from '@taquito/tezbridge-signer';
// import { InMemorySigner } from '@taquito/signer';
// import txAbi from "../utils/tx.json"

const Featured = () => {
  const classes = useStyles();
  const { provider } = useWalletConnect();

  const [bytes, setBytes] = useState('');
  const [addr, setAddr] = useState('');
  const [result, setResult] = useState('');
  const [isLoading, setIsLoading] = useState(false);
// KT1C5kLc9y8yvCaiqPaHBaW9EKngeMirMeSM
// { "prim": "Right",
// "args":
//   [ { "prim": "Left",
//       "args":
//         [ { "prim": "Pair",
//             "args":
//               [ { "prim": "Pair",
//                   "args":
//                     [ [ { "prim": "DROP" },
//                         { "prim": "NIL",
//                           "args": [ { "prim": "operation" } ] },
//                         { "prim": "PUSH",
//                           "args":
//                             [ { "prim": "address" },
//                               { "string":
//                                   "tz1aSkwEot3L2kmUvcoxzjMomb9mvBNuzFK6" } ] },
//                         { "prim": "CONTRACT",
//                           "args": [ { "prim": "unit" } ] },
//                         { "prim": "IF_NONE",
//                           "args":
//                             [ [ { "prim": "PUSH",
//                                   "args":
//                                     [ { "prim": "string" },
//                                       { "string":
//                                           "bad address for get_contract" } ] },
//                                 { "prim": "FAILWITH" } ], [] ] },
//                         { "prim": "PUSH",
//                           "args":
//                             [ { "prim": "mutez" }, { "int": "1000000" } ] },
//                         { "prim": "UNIT" }, { "prim": "TRANSFER_TOKENS" },
//                         { "prim": "CONS" } ], { "prim": "True" } ] },
//                 { "int": "1555200" } ] } ] } ] }
  const deploy = async (e) => {
    e.preventDefault()
    setResult('')
    if (!provider) return
    try {
      setIsLoading(true);
      console.log(provider.wallet)
      const contract = await provider.wallet.at(addr)
      const op = await provider.wallet.transfer({
        to: contract.address,
        amount: 0,
        parameter: {
          entrypoint: "propose",
          value: await JSON.parse(bytes).args[0].args[0]
        },
      }).send();
      console.log(`Awaiting for ${op.opHash} to be confirmed...`);
      setResult(op.opHash)
      const hash = await op.confirmation(1).then(() => op.opHash);
      setResult(hash);
      console.log(`Operation injected: https://granadanet.tzkt.io/${hash}`)
      setIsLoading(false);
    } catch (err) {
      console.error(err)
      setIsLoading(false);
    }
  }

  return (
    <section className={classes.details}>
      <Container className={classes.container}>
        <div className={classes.background}>
          <Typography variant="h1" className={classes.title}>
            Make transaction using multisig
          </Typography>
          <hr className={classes.hrTag} />

          <form onSubmit={deploy} className={classes.form}>

            <div className={classes.inputContainer}>
              <label htmlFor="hash">Multisig Address</label>
              <input
                type="text"
                value={addr}
                onChange={(e) => setAddr(e.target.value)}
                required
              />
            </div>
            <div className={classes.inputContainer}>
              <label htmlFor="hash">Proposed Bytes</label>
              <textarea
                type="text"
                value={bytes}
                onChange={(e) => setBytes(e.target.value)}
                required
                style={{ width: '-webkit-fill-available' }}
              />
            </div>

            <Button
              type="submit"
              disabled={!isLoading ? false : true}
              className={`${classes.btn} ${classes.filled} ${isLoading && classes.btnWithLoader}`}
            >
              {isLoading ? "Verifying..." : "Send Transaction"}

              {isLoading && (
                <CircularProgress
                  className={`${classes.loading}`}
                  size={24}
                />
              )}
            </Button>
          </form>
          {result && <p>Operation Injected <a href={`https://granadanet.tzkt.io/${result}`}>{result}</a></p>}
        </div>
      </Container>
    </section>
  );
};

const useStyles = makeStyles((theme) => ({
  ...theme.overrides.mui,
  ...theme.overrides.formStyle,
  details: {
    position: "relative",
    overflow: "hidden",
  },
  background: {
    width: '100%',
    margin: 'auto',
    height: '100%',
    borderRadius: 25,
    textAlign: 'center',
  },
  title: {
    fontSize: 32,
    fontWeight: 900,
    color: 'black',
    marginTop: 30
  },
  hrTag: {
    height: 5,
    background: '#5f3d7a'
  },
  smallTitle: {
    fontSize: 22,
    marginTop: 20,
    fontWeight: 700,
  },
  nftList: {
    marginTop: 16,
    width: '90%',
    margin: 'auto',
    display: 'grid',
    gridGap: 16,
    gridTemplateColumns: 'repeat(2, 1fr)',
    "@media (max-width:600px)": {
      gridTemplateColumns: 'repeat(1, 1fr)',
    },
  },
  mainImg: {
    width: '100%',
    height: 200,
    margin: 'auto',
    border: '2px solid #1F3C88',
    borderRadius: 10,
  },
}));

export default Featured;
